import React from 'react';

interface InputAreaProps {
  label: string;
  required?: boolean;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  name: string;
  error?: string;
}

const InputArea = ({
  label,
  required = false,
  placeholder = '',
  value,
  onChange,
  name,
  error,
}: InputAreaProps) => {
  return (
    <div className="mb-[40px]">
      <label className="text-2xl md:text-3xl lg:text-xl font-semibold text-[#000000] leading-[120%]">
        {label} {required && <span className="text-[#E43E7A]">*</span>}
      </label>
      <textarea
        name={name}
        required={required}
        className={`w-full border ${error ? 'border-red-500' : 'border-[#D9D9D9]'} rounded-none px-4 py-4 mt-1 h-[180px] md:h-[240px] text-2xl md:text-3xl lg:text-xl font-Regular placeholder-[#BDBDBD] focus:ring-0 focus:border-[#E43E7A] mt-4`}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
      />
      {error && (
        <div className="mt-2">
          <p className="text-[#E43E7A] text-lg md:text-2xl lg:text-lg font-medium">
            {error}
          </p>
        </div>
      )}
    </div>
  );
};

export default InputArea; 